// All available actions to mutate state are stored here and
// imported as needed into action and reducer files. This allows
// you to see at a glance all possible mutations to client and
// session data

// Group alphabetically or by module
export const API_EXECUTE = 'API_EXECUTE'
export const API_EXECUTE_COMPLETED = 'API_EXECUTE_COMPLETED'

export const GET_OUTPUT = 'GET_OUTPUT'
export const GET_OUTPUT_FAIL = 'GET_OUTPUT_FAIL'
export const GET_OUTPUT_SUCCESS = 'GET_OUTPUT_SUCCESS'

export const GET_RCLOOKUPDATA = 'GET_RCLOOKUPDATA'
export const GET_RCLOOKUPDATA_FAIL = 'GET_RCLOOKUPDATA_FAIL'
export const GET_RCLOOKUPDATA_SUCCESS = 'GET_RCLOOKUPDATA_SUCCESS'

export const GET_RC_USER_DATA = 'GET_USERDATA'
export const GET_RC_USER_DATA_FAIL = 'GET_USERDATA_FAIL'
export const GET_RC_USER_DATA_SUCCESS = 'GET_USERDATA_SUCCESS'

export const SET_USER_RC_DATA = 'SET_USER_RC_DATA'
export const SET_USER_RC_DATA_FAIL = 'SET_USER_RC_DATA_FAIL'
export const SET_USER_RC_DATA_SUCCESS = 'SET_USER_RC_DATA_SUCCESS'

export const VALIDATE = 'VALIDATE'

export const CHANGE_INPUT = 'CHANGE_INPUT'

export const RESET_SAVE_SUCCESS = 'RESET_SAVE_SUCCESS'


// WEBPACK FOOTER //
// ./state/action-types.js